import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Reminder() {
    const [reminderName, setReminderName] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventTime, setEventTime] = useState("");
    const [recipients, setRecipients] = useState([]);
    const [timings, setTimings] = useState([]);
    const [alertMsg, setAlertMsg] = useState("");
    const [showAlertBox, setShowAlertBox] = useState(false);
    const navigate = useNavigate();

    const handleTiming = (e) => {
        const value = e.target.value;

        if (e.target.checked) {
            setTimings([...timings, value]);
        } else {
            setTimings(timings.filter(t => t !== value));
        }
    };

    const addRecipient = () => {
        setRecipients([
            ...recipients,
            { name: "", email: "" }
        ]);
    };

    const updateRecipient = (index, field, value) => {
        const updated = [...recipients];
        updated[index][field] = value;
        setRecipients(updated);
    };

    const removeRecipient = (index) => {
        const updated = recipients.filter((_, i) => i !== index);
        setRecipients(updated);
    };

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg("");
        localStorage.setItem('communications', 'campaign');
        navigate('/redirect_communications');
    };

    const senReminder = () => {

        let company_id = localStorage.getItem('mem_company_id');

        const data = {
            company_id: company_id,
            reminder_name: reminderName,
            subject,
            message,
            event_date: eventDate,
            event_time: eventTime,
            recipients: recipients,
            timings: timings
        };

        // Validation
        if (!reminderName) {
            showAlert("Reminder name required");
            return;
        }

        if (recipients.length === 0) {
            showAlert("Add at least one recipient");
            return;
        }

        if (timings.length === 0) {
            showAlert("Select at least one timing");
            return;
        }

        fetch("create_reminder.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(res => {
                if (res.status === "success") {
                    showAlert("Reminder saved successfully.");
                }
            });
    };
    return (
        <div>
            <div className='fullwidth pull_left'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Create Reminder</h2>

                </div>
            </div>
            <div className='vl_dsh_formnholder'>
                <div className='row'>
                    <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Reminder Name</label>
                            <input placeholder="Reminder Name" onChange={(e) => setReminderName(e.target.value)} />
                        </div>
                    </div>
                    <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Event Date</label>
                            <input type="date" onChange={(e) => setEventDate(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className='row'>

                    <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Event Time</label>
                            <input type="time" onChange={(e) => setEventTime(e.target.value)} />
                        </div>
                    </div>

                    <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Subject</label>
                            <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                    </div>

                </div>
                <div className='row'>
                     <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Message</label>
                            <textarea value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                        </div>
                    </div>

                    <div className='vl_dsh_one_half'>
                        <div className='formfieldcommon'>
                            <label>Select Time For Reminder</label>
                            <label>
                                <input
                                    type="checkbox"
                                    value="1_day"
                                    onChange={(e) => handleTiming(e)}
                                />
                                1 Day Before
                            </label>

                            <label>
                                <input
                                    type="checkbox"
                                    value="1_hour"
                                    onChange={(e) => handleTiming(e)}
                                />
                                1 Hour Before
                            </label>
                        </div>
                    </div>
                </div>
                <div className='separator'>
                    <h4>Add Reicipient</h4>
                </div>
                <div className='reicipient_area fullwidth pull_left'>
                    <div className='vl_dsh_buttonholder'>
                        <button className="greenbutton pull_left mr-10" onClick={addRecipient}>+ Add Recipient</button>
                    </div>
                    <div className='reicipientblock fullwidth pull_left'>
                        {recipients.map((r, index) => (
                            <div className='reicipient_row' key={index}>
                                <input type="text" placeholder="Name" value={r.name} onChange={(e) => updateRecipient(index, 'name', e.target.value)} className="reicipient_name_input" />

                                <input type="email" placeholder="Email" value={r.email}
                                    onChange={(e) => updateRecipient(index, 'email', e.target.value)}
                                    className="reicipient_mail_input" />

                                <button className='borderbutton pull_left mt-7' onClick={() => removeRecipient(index)}><i class="ri-close-circle-line"></i> Remove</button>

                            </div>

                        ))}

                    </div>
                </div>
                <div className='fullwidth pull_left mt-30'>
                    <button className='pull_right green_button send_btn' onClick={senReminder}>Send</button>
                    <button className='pull_right borderbutton mr-10'>Cancel</button>
                </div>
            </div>
            {showAlertBox && (
                <div className='vl_dsh_popup_vis'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>
                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}

            <div className='loaderpop' id='waitloader'>
                <div className='loader_inner' id="waitloaderinner">
                    <p id="loadtext"></p>
                </div>
            </div>
        </div>
    )
}
